'use strict';
/**
 *  Load modules
 */

global.jQuery = $;
global.$ = $;

require('./modules/jquery-ui.min.js');

require('./modules/jquery-ui-touch-punch.min.js');

require('./modules/custom-select.js');

require('./modules/slick.min.js');

import '../scss/app.scss';
import functions from './modules/functions.js';
import './modules/scripts.js';
import './modules/shop-scripts.js';
$(document).ready(function () {
  functions();
});